import { meterTrack, VIZ } from '~/pages/backoffice/admin/dashboard/viz'

/** Rayon et circonférence de l'anneau, en unités du viewBox. */
const RING_RADIUS = 54
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS

/**
 * Anneau de complétion : un **meter**, pas un camembert.
 *
 * La maquette montre un anneau avec un grand pourcentage au centre. C'est un
 * ratio unique rapporté à son plafond — la forme juste est donc un meter, et le
 * nombre est le graphique. Un camembert à deux parts (« terminé » contre « le
 * reste ») dirait la même chose en moins lisible ; la répartition complète, elle,
 * vit dans la barre empilée en dessous, qui est la forme des parts d'un tout.
 *
 * La piste est un pas plus clair de la même teinte que le remplissage, pas un
 * gris : c'est ce qui fait lire l'état sur tout l'anneau et pas seulement sur
 * l'arc rempli.
 */
function CompletionRing({ value }: { value: number }) {
  const filled = (value / 100) * RING_CIRCUMFERENCE

  return (
    <svg viewBox="0 0 128 128" className="size-32 shrink-0 -rotate-90" role="presentation">
      {/*
        La piste passe par `style` et non par l'attribut `stroke` : `color-mix()`
        est une valeur CSS, et son support en attribut de présentation SVG n'est
        pas acquis partout. En attribut, un navigateur qui ne la comprend pas
        n'affiche aucune piste — l'anneau perdrait sa moitié vide sans que rien
        ne le signale.
      */}
      <circle
        cx="64"
        cy="64"
        r={RING_RADIUS}
        fill="none"
        style={{ stroke: meterTrack(VIZ.good) }}
        strokeWidth="12"
      />
      <circle
        cx="64"
        cy="64"
        r={RING_RADIUS}
        fill="none"
        stroke={VIZ.good}
        strokeWidth="12"
        strokeLinecap="round"
        strokeDasharray={`${filled} ${RING_CIRCUMFERENCE - filled}`}
      />
    </svg>
  )
}

export default CompletionRing
